import { FaUserAlt } from "react-icons/fa";
import {BiAnalyse,BiLogOutCircle,BiUserCircle} from 'react-icons/bi'
import {AiOutlineSend,AiFillDelete, AiOutlineCalendar,AiOutlineCheck,AiOutlineBell,AiOutlineFundProjectionScreen,AiOutlineSearch,AiOutlineDashboard,AiOutlineUser,AiFillWechat,AiOutlineProject,AiFillSetting} from 'react-icons/ai'
import {IoAnalyticsOutline} from 'react-icons/io5'
import {RiMoneyDollarBoxFill} from 'react-icons/ri'
import {BsCashCoin,BsArrowsFullscreen,BsListTask} from 'react-icons/bs'
import {GrCompliance} from 'react-icons/gr'
import {MdDriveFileRenameOutline,MdDescription ,MdDateRange} from 'react-icons/md'
import {IoIosArrowBack} from 'react-icons/io'
export const icons = {
	FaUserAlt,BiAnalyse,AiOutlineDashboard,BiLogOutCircle,
	AiOutlineUser,AiFillWechat,AiOutlineProject,IoAnalyticsOutline,AiFillSetting,
	AiOutlineSearch,RiMoneyDollarBoxFill,BsCashCoin,GrCompliance,MdDriveFileRenameOutline,
	AiOutlineFundProjectionScreen,AiOutlineBell,BsArrowsFullscreen,AiOutlineCalendar,
	IoIosArrowBack,AiOutlineCheck,AiOutlineSend,AiFillDelete,MdDescription,MdDateRange,
	BiUserCircle,BsListTask
}